import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Col,
  Card,
  CardBody,
  Button
} from "reactstrap"
import AddShipment from "./components/addShipment";
import Shipments from "./components/shipments";

const Patient = () => {
  const [isForm, setIsForm] = useState(1);
  useEffect(() => {
    console.log(isForm)
  }, [isForm])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Shipments | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* <h4>Shipments</h4> */}
          <Card>
            <CardBody>
              <div className="row align-items-center ">
                <Col xs={12} md={6}>
                  <span style={{ fontSize: '18px', fontWeight: 600 }}>Add New Shipment</span>
                </Col>
                <Col xs={12} md={6} className="mt-2 mt-md-0">
                  <div className="d-flex flex-wrap flex-md-nowrap justify-content-between justify-content-md-end text-md-end">
                    <div className="w-50 w-md-auto pe-1">
                      <Button
                        className={`w-100 w-md-auto bx bx-plus-circle py-2 px-3 ${isForm === 1 ? 'btn-premium' : 'btn-outline-secondary'}`}
                        onClick={() => setIsForm(1)}
                        style={{ border: isForm === 1 ? 'none' : '1px solid rgba(255,255,255,0.12)', background: isForm === 1 ? '' : 'rgba(255,255,255,0.02)', color: isForm === 1 ? '#fff' : '#9ca3af', transition: 'all 0.2s ease' }}
                      >
                        <span className="ms-2 font-size-13 fw-semibold">Add New Shipment</span>
                      </Button>
                    </div>
                    <div className="w-50 w-md-auto ps-1">
                      <Button
                        className={`w-100 w-md-auto bx bx-list-ol py-2 px-3 ${isForm === 2 ? 'btn-premium' : 'btn-outline-secondary'}`}
                        onClick={() => setIsForm(2)}
                        style={{ border: isForm === 2 ? 'none' : '1px solid rgba(255,255,255,0.12)', background: isForm === 2 ? '' : 'rgba(255,255,255,0.02)', color: isForm === 2 ? '#fff' : '#9ca3af', transition: 'all 0.2s ease' }}
                      >
                        <span className="ms-2 font-size-13 fw-semibold">Shipments</span>
                      </Button>
                    </div>
                  </div>
                </Col>
              </div>
            </CardBody>
          </Card>
          {isForm === 1 ? <AddShipment /> : <Shipments />}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Patient;
